const searchFormDefaults = {
  ticketSearch: '',
};
export default searchFormDefaults;
